import React from 'react';
import { Button, Descriptions, Typography } from 'antd';
import { copyText } from '../../utils/clipboard';
import { relativeTime } from '../../utils/relativeTime';
import { fullDateTime } from '../../utils/dateTimeFormat';

const { Text, Paragraph } = Typography;

function chatTypeLabel(chatType) {
  if (chatType === 'private') return 'Direct message';
  if (chatType === 'supergroup') return 'Supergroup';
  if (chatType === 'channel') return 'Channel';
  if (chatType === 'group') return 'Group';
  return chatType || 'Unknown';
}

export default function BotActivityContextPanel({ conversation, bot, onCopyChatId }) {
  if (!conversation) {
    return (
      <div className="bam-context-empty">
        <Text type="secondary">Select a conversation to see details.</Text>
      </div>
    );
  }

  const handleCopyId = () => {
    copyText(conversation.platform_chat_id);
    onCopyChatId?.();
  };

  return (
    <div className="bam-context-inner">
      <Text strong className="bam-context-title">Chat details</Text>
      <Descriptions column={1} size="small" className="bam-context-desc">
        <Descriptions.Item label="Title">
          {conversation.chat_title || conversation.platform_chat_id}
        </Descriptions.Item>
        <Descriptions.Item label="Type">
          {chatTypeLabel(conversation.chat_type)}
        </Descriptions.Item>
        <Descriptions.Item label="Chat ID">
          <Button type="link" size="small" onClick={handleCopyId} style={{ padding: 0, height: 'auto' }}>
            {conversation.platform_chat_id}
          </Button>
        </Descriptions.Item>
        <Descriptions.Item label="Platform">
          {bot?.platform === 'telegram_userbot' ? 'Telegram' : bot?.platform}
        </Descriptions.Item>
        <Descriptions.Item label="Messages">
          {conversation.message_count}
        </Descriptions.Item>
        <Descriptions.Item label="Sessions">
          {conversation.session_count}
        </Descriptions.Item>
        <Descriptions.Item label="Declined">
          {conversation.declined_count || 0}
        </Descriptions.Item>
        <Descriptions.Item label="First seen">
          {fullDateTime(conversation.created_at)}
        </Descriptions.Item>
        <Descriptions.Item label="Last activity">
          {relativeTime(conversation.last_activity_at)}
        </Descriptions.Item>
        {conversation.participants?.length > 0 && (
          <Descriptions.Item label="Participants">
            {conversation.participants.join(', ')}
          </Descriptions.Item>
        )}
      </Descriptions>

      <Paragraph type="secondary" className="bam-privacy-note">
        <Text strong>Activity scope.</Text>{' '}
        Only messages the bot received and replied to appear here. The rest of the Telegram chat
        history is not synced.
      </Paragraph>
    </div>
  );
}
